<template>
  <v-app>
    <v-app-bar
      app
      color="white"
      height="100"
    >
      

      <v-toolbar-title class="d-none d-md-flex">
        <v-row>
          <v-col cols="12 mb-0 pb-0">
            <h2 class="font-weight-black">CIRCUITO DE PALESTRAS DE COMPUTAÇÃO</h2>
          </v-col>
          <v-col cols="12 pt-0 mt-0">
            <span class="text-md-subtitle-1 font-weight-bold"> IFRS - IBIRUBÁ/RS - 20 a 24/07/2020 e 27 a 31/07/2020</span>
          </v-col>
        </v-row>
         
      </v-toolbar-title>

      <v-toolbar-title class="d-flex d-sm-none d-none d-sm-flex d-md-none font-weight-black text-sm-body-1 headline">
        Circuito de Palestras<br>IFRS - Ibirubá
      </v-toolbar-title>
    
    
    
    </v-app-bar>

    <v-main>
      
      <v-sheet
        id="contact"
        color="#333333"
        dark
        tag="section"
        tile
      >
        <div class="py-12"></div>

        <v-container>
          <v-responsive class="mx-auto mb-12">
            <h4 class="text-md-h4 text-sm-body-2 text-lg-h4 font-weight-bold mb-3 text-uppercase text-center">Lista de Presenças por Palestra</h4>
          </v-responsive>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

              <v-row> 
                <v-col cols="12">
                    <v-select
                        v-model="palestra"
                        :items="palestras"
                        label="Selecione uma palestra"
                        
                        ></v-select>
                </v-col>
                
                <v-col cols="12">
                    <v-data-table
                        dense
                        :headers="headers"
                        :items="presencas"
                        :items-per-page="20"
                        class="elevation-1"
                        :search="palestra"
                    >
                    </v-data-table>
                </v-col>
            </v-row> 
        
        </v-container>

        <div class="py-12"></div>
      </v-sheet>
    </v-main>

    <v-footer
      class="justify-center"
      color="#292929"
      height="100"
    >
      <div class="title font-weight-light grey--text text--lighten-1 text-center">
        &copy; {{ (new Date()).getFullYear() }} — Computação - IFRS - Ibirubá
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import moment from 'moment'

export default {
  name: 'App',

  data: () => ({
    search: '',
    headers: [
        
        { text: 'Palestra', value: 'palestraTitulo' },
        { text: 'E-mail', value: 'usuarioEmail' },
        { text: 'IP', value: 'usuarioIp' },
        { text: 'Data Assinatura', value: 'dataAssinatura' },
        { text: 'Rating Palestra', value: 'palestraRatingPalestra' },
        { text: 'Rating Transmissão', value: 'palestraRatingTransmissao' },
    ],
    
    presencas: [],
    presencasFiltradas: [],
    comentarios: [],
    palestra: '', 
    palestras: [
        { text: 'Rogers Prates de Pelle - Uma reflexão sobre como a pandemia acelerou um movimento natural no mundo corporativo e acadêmico. - 20/07/2020 às 19h'},
        { text: 'Alexandre Zamberlan - Computação e Nanotecnologia - 21/07/2020 às 19h'},
        { text: 'Fernando Marcondes - Reinvenção no modelo de trabalho durante a pandemia - 22/07/2020 às 19h'},
        { text: 'Lúcio Lopes Diniz - A importância do Teste de Software para a qualidade dos Sistemas - 23/07/2020 às 19h'},
        { text: 'José Eduardo Venson - Como desenvolver carreira de computação na área da saúde - 24/07/2020 às 19h'},
        { text: 'Lisiane Oliveira - Territórios de Inventar: Computação e a Educação OnLIFE - 27/07/2020 às 19h'},
        { text: 'Ernando Silva - Business Intelligence: conceitos, ferramentas, aplicações e tendências - 28/07/2020 às 19h'},
        { text: 'Roberto Wiest - Computação e Agro: Pesquisas e Oportunidades - 29/07/2020 às 19h'},
        { text: 'Joel Luís Carbonera - Inteligência Artificial - 30/07/2020 às 19h'},
        { text: 'Eliane Schlemmer - Ecossistemas de Inovação na Educação OnLIFE - 31/07/2020 às 19h'},
    ],
  }),

  async created() {
      try{
          this.$http.get('presenca.json').then(
                res => {
                    for (const [key, value] of Object.entries(res.data)) {
                        this.presencas.push(
                          {
                              usuarioEmail: value.usuarioEmail.toLowerCase(),
                              palestraTitulo: value.palestraTitulo,
                              palestraComentario: value.palestraComentario,
                              dataAssinatura: moment(value.dataAssinatura).format('DD/MM/YYYY hh:mm:ss'),
                              palestraRatingPalestra: value.palestraRatingPalestra,
                              palestraRatingTransmissao: value.palestraRatingTransmissao,
                              palestraRatingDuracao: value.palestraRatingDuracao,
                              palestraId: value.palestraId,
                              usuarioIp: value.usuarioIp,
                              key: key
                          }
                        )
                    }
                    console.log(this.presencas)
                }
           )        
      }catch(e){
          console.log("Houve erro: " + e)
      }
  },

  methods: {
      selecionaPalestra(){
          console.log("Palestra selecionada: " + this.palestra)
          let teste = this.presencas.filter( (presenca) => {
              return presenca.palestraId == this.palestra
          })
          this.presencasFiltradas = teste
      }
  }
};
</script>
